import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { MsSupportChatSurvey } from './ms-support-chat-survey';

const keyWordList = ['payment option', 'prepay', 'postpay', 'monthly invoicing'];
const botEnabled = (pilotEnabled, issueDescription, language) => pilotEnabled
  && _.find(keyWordList, keyWord => issueDescription.toLowerCase().indexOf(keyWord) !== -1)
  && language.toLowerCase() === 'en';

class MsSupportChatFormInternal extends React.PureComponent {
  static propTypes = {
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    virtualAgentInfo: PropTypes.PropTypes.shape({
      market: PropTypes.string,
    }),
    i18n: PropTypes.shape({
      getString: PropTypes.func,
      getCldr: PropTypes.func,
    }).isRequired,
    context: PropTypes.shape({
      accountNumber: PropTypes.string,
      flowId: PropTypes.string,
    }),
    featureName: PropTypes.string,
    permissions: PropTypes.shape({
      DFAChatPhase1: PropTypes.bool,
    }),
    resourcePath: PropTypes.string,
    activity: PropTypes.shape({
      signal: PropTypes.func,
      trace: PropTypes.func,
    }),
    logger: PropTypes.shape({
      trace: PropTypes.func,
      error: PropTypes.func,
    }),
    market: PropTypes.shape({
      region: PropTypes.string,
      language: PropTypes.string,
    }),
  };

  static defaultProps = {
    permissions: {},
    featureName: '',
    context: {
      accountNumber: '',
      flowId: 'advertiser',
    },
    virtualAgentInfo: undefined,
    activity: { signal: _.noop, trace: _.noop },
    logger: { trace: _.noop, error: _.noop },
    resourcePath: 'https://ui.ads.microsoft.com/campaign/virtualagent',
    market: undefined,
  };

  onSubmit = ({
    description,
    issue,
    customSupportLink,
  }) => {
    const {
      virtualAgentInfo,
      market,
    } = this.props;
    let { language, region } = this.props.i18n.getCldr().attributes;
    if (market) {
      ({ language, region } = market);
    }
    const isVritualAgent = !!botEnabled(virtualAgentInfo, description, language);
    const contextArray = [
      { name: 'description', value: description },
      { name: 'account number', value: this.props.context.accountNumber },
    ];

    this.props.activity.signal(`onSubmit: open a new window, language: ${language}, region: ${region}`);
    this.props.logger.trace(`support-chat-modal: onSubmit', 'onSubmit: open a new window, language: ${language}, region: ${region}`);
    const modalityType = 'occhat';

    window.open(
      customSupportLink || `${this.props.resourcePath}?locale=${language}-${region}&virtual=${isVritualAgent}&modality=${modalityType}&issue=${issue}&context=${encodeURIComponent(JSON.stringify(contextArray))}&description=${encodeURIComponent(description)}&flowid=${this.props.context.flowId || 'advertiser'}`,
      '_blank', 'width=360,height=480,resizable=1,scrollbars=1'
    );

    this.props.onSuccess();
  };

  render() {
    const {
      i18n,
      featureName,
      permissions,
      onCancel,
      activity,
      logger,
      market,
    } = this.props;

    let { language, region } = this.props.i18n.getCldr().attributes;
    if (market) {
      ({ language, region } = market);
    }

    activity.signal(`MsSupportChatFormInternal render, language: ${language}, region: ${region}`);
    logger.trace(`support-chat-modal: render', 'MsSupportChatFormInternal render, language: ${language}, region: ${region}`);

    return (
      <MsSupportChatSurvey
        {...this.props}
        onSubmit={this.onSubmit}
        onCancel={onCancel}
        i18n={i18n}
        featureName={featureName}
        permissions={permissions}
        activity={activity}
        logger={logger}
        market={market}
        onSubmitControlRole="link"
      />
    );
  }
}

export const MsSupportChatForm = withActivityContext(MsSupportChatFormInternal);
